var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80483 4.52652L5.4715 1.19385C5.23083 0.947182 4.79817 0.923849 4.52817 1.19385L1.1955 4.52652C0.934833 4.78718 0.934833 5.20852 1.1955 5.46918C1.45617 5.72985 1.8775 5.72985 2.13817 5.46918L4.3335 3.27385V16.3312C4.3335 16.6998 4.6315 16.9978 5.00017 16.9978C5.36817 16.9978 5.66683 16.6998 5.66683 16.3312V3.27385L7.86217 5.46918C8.12283 5.72985 8.54417 5.72985 8.80483 5.46918C9.0655 5.20852 9.0655 4.78718 8.80483 4.52652Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 18,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxIconUp);
export default __webpack_public_path__ + "static/media/mxIconUp.a5f7316c4df289356be55f3fb6f203f6.svg";
export { ForwardRef as ReactComponent };